import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { Routes, Route } from "react-router-dom";

import LicenseActivation from "./pages/LicenseActivation";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

import Dashboard from "./pages/Dashboard";
import Billing from "./pages/Billing";
import Products from "./pages/Products";
import Sales from "./pages/Sales";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import AddProduct from "./pages/AddProduct";
import Customers from "./pages/Customers";
import AddCustomer from "./pages/AddCustomer";
import GSTBilling from "./pages/GSTBilling";
import Suppliers from "./pages/Suppliers";
import Inventory from "./pages/Inventory";
import PurchaseDashboard from "./pages/PurchaseDashboard";
import ExpenseDashboard from "./pages/ExpenseDashboard";
import Login from "./pages/Login";

import GSTDashboard from "./pages/GSTDashboard";
import AccountsDashboard from "./pages/AccountsDashboard";
import EmployeesDashboard from "./pages/EmployeesDashboard";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import MarketingDashboard from "./pages/MarketingDashboard";
import NotificationsDashboard from "./pages/NotificationsDashboard";
import Subscription from "./pages/Subscription";
import HelpSupport from "./pages/HelpSupport";

import "./styles/App.css";
// Note: I removed the SplashScreen.css and logo imports since they are no longer needed here.

function App() {
  const [isActivated, setIsActivated] = useState(
    localStorage.getItem("isActivated") === "true"
  );

  const [isExpired, setIsExpired] = useState(false);

  // LOGIN STATE
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );

  useEffect(() => {
    const checkExpiry = async () => {
      try {
        const shopId = localStorage.getItem("shopId");
        if (!shopId) return;

        const licensesRef = await getDoc(doc(db, "shops", shopId));
        if (!licensesRef.exists()) return;

        const shopData = licensesRef.data();
        const licenseKey = shopData.licenseKey;

        const licenseDoc = await getDoc(doc(db, "licenses", licenseKey));
        if (!licenseDoc.exists()) return;

        const expiryDate = licenseDoc.data().expiryDate;
        const today = new Date();
        const expiry = new Date(expiryDate);

        if (today > expiry) {
          setIsExpired(true);
        }
      } catch (error) {
        console.error(error);
      }
    };

    checkExpiry();
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        localStorage.setItem("isLoggedIn", "true");
        setIsLoggedIn(true);
      } else {
        localStorage.removeItem("isLoggedIn");
        setIsLoggedIn(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // 1. Activation Check
  if (!isActivated) {
    return <LicenseActivation setIsActivated={setIsActivated} />;
  }

  // 2. Expiration Check
  if (isExpired) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h1>License Expired</h1>
        <p>Please contact support to renew your license.</p>
      </div>
    );
  }

  // 3. Login Check
  if (!isLoggedIn) {
    return (
      <Routes>
        <Route path="*" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
      </Routes>
    );
  }

  // 4. MAIN SOFTWARE / DASHBOARD
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Topbar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/gst-billing" element={<GSTBilling />} />
          <Route path="/products" element={<Products />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/expenses" element={<ExpenseDashboard />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/gst-tax" element={<GSTDashboard />} />
          <Route path="/accounts" element={<AccountsDashboard />} />
          <Route path="/employees" element={<EmployeesDashboard />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/marketing" element={<MarketingDashboard />} />
          <Route path="/notifications" element={<NotificationsDashboard />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/support" element={<HelpSupport />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/purchases" element={<PurchaseDashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/add-product" element={<AddProduct />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/add-customer" element={<AddCustomer />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;